<template>
  <div class="card">
    <div class="card-body">
      <div class="clearfix">
        <h4 class="card-title mb-4">User Activity</h4>
        <div class="row mb-4">
          <div class="col-12">
            <div class="d-flex">
              <multiselect v-model="activityUserSelected" placeholder="All" :options="users.objects" label="name" track-by="name" class="dashboard-select me-3 w-100" open-direction="bottom"
                           :searchable="true" :internal-search="false" @search-change="asyncFindUser" :multiple="true">
                <span slot="noResult">No user found. Change search query.</span>
              </multiselect>
              <button class="btn btn-primary me-1" @click="userActivitySearch">Search activity</button>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-4" />
      <div class="mt-2">
        <ul class="verti-timeline list-unstyled" v-for="(activity, index) in userActivityReport.objects" :key="index">
          <li class="event-list mb-4">
            <div class="event-timeline-dot">
              <i class="bx bx-right-arrow-circle font-size-18"></i>
            </div>
            <div class="d-flex">
              <div class="me-3">
                <h5 class="font-size-14">
                  {{formatDate(activity.activityDate)}}
                  <i
                      class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"
                  ></i>
                </h5>
              </div>
              <div class="flex-grow-1">
                <div>
                  {{ activity.activityMessage }}
                </div>
              </div>
            </div>
          </li>
        </ul>
        <b-pagination
            v-if="userActivityReport.total > 0"
            v-model="userActivityCurrentPage"
            :total-rows="userActivityReport.total"
            :per-page="30"
            class="mt-3"
            size="lg"
            align="center"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {SIMPLE_SYSTEM_USERS, USER_ACTIVITY_REPORT} from "@/gql";
import moment from "moment";
import Multiselect from "vue-multiselect";

export default {
  name: "UserActivity",
  components: {Multiselect},
  data(){
    return {
      activityUserSelected: {
        id: JSON.parse(localStorage.getItem('activeUser')).publicId,
        name: JSON.parse(localStorage.getItem('activeUser')).name
      },
      users: {
        objects: []
      },
      perPage: 30,
      searchUsers: "",
      userActivityUsers: [JSON.parse(localStorage.getItem('activeUser')).publicId],
      userActivityReport: {
        objects: []
      },
      userActivityCurrentPage: 1,
    }
  },
  apollo: {
    users: {
      query: SIMPLE_SYSTEM_USERS,
      variables(){
        return {
          page: 1,
          perPage: this.perPage,
          searchKeyword: this.searchUsers
        }
      }
    },
    userActivityReport: {
      query: USER_ACTIVITY_REPORT,
      variables(){
        return {
          page: this.userActivityCurrentPage,
          perPage: this.perPage,
          users: this.userActivityUsers
        }
      }
    }
  },
  // created(){
  //   this.users.push(JSON.parse(localStorage.getItem('activeUser')).publicId)
  // },
  methods: {
    formatDate(date){
      return moment(date).format('DD MMM YYYY')
    },
    userActivitySearch(){
      const users = []
      this.activityUserSelected.forEach(user => {
        users.push(user.publicId)
      })
      this.userActivityUsers = users
      console.log(users)
    },
    asyncFindUser(query){
      this.searchUsers = query
    },
  }
}
</script>

<style scoped>

</style>
